import React from "react";
import { XCircleIcon, CheckCircle2Icon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { beforeItems, afterItems } from "../../data/clinicalDecisions";
export function BeforeAfterSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-94" data-mp="3ah0k5zxiimee">
      <div className="mx-auto max-w-6xl" data-id="element-95" data-mp="3fe0s6gdx9z85">
        <h2 className="text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-96" data-mp="3ff2bt9907u1h">
          What Changes When You Stop Planning From Memory?
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-97" data-mp="bwsdu6ielhi6">
          <div className="overflow-hidden rounded-3xl bg-white ring-1 ring-navy/10" data-id="element-98" data-mp="3tebm5saj3txj">
            <div className="bg-cream-dark px-6 py-5" data-id="element-99" data-mp="3tch6ase46s0b">
              <p className="text-sm font-extrabold uppercase tracking-widest text-wine" data-id="element-100" data-mp="26pk243gjzis">Before</p>
              <p className="mt-1 font-serif text-2xl font-bold text-navy" data-id="element-101" data-mp="pwtb7bzgm6sw">Without a Structured Framework</p>
            </div>
            <ul className="divide-y divide-navy/10 px-6" data-id="element-102" data-mp="upmhi4aktn73">
              {beforeItems.map(item => <li key={item} className="flex gap-3 py-4" data-id="element-103" data-mp="22m05qeqgcei9">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-wine" aria-hidden="true" data-id="element-104" data-mp="1xq2mo0nt0u1s" />
                  <span className="text-base text-muted" data-id="element-105" data-mp="2cez4uqjkrng4">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl bg-navy ring-1 ring-navy" data-id="element-106" data-mp="27l4c6xlzry4w">
            <div className="bg-cta px-6 py-5" data-id="element-107" data-mp="2ld12qx80hzz6">
              <p className="text-sm font-extrabold uppercase tracking-widest text-white/90" data-id="element-108" data-mp="2gfrehkwczucx">After</p>
              <p className="mt-1 font-serif text-2xl font-bold text-white" data-id="element-109" data-mp="2vci4x4o21vqe">
                With Interceptive Orthodontics Blueprint™
              </p>
            </div>
            <ul className="divide-y divide-white/10 px-6" data-id="element-110" data-mp="2qbm0mpzsk7kg">
              {afterItems.map(item => <li key={item} className="flex gap-3 py-4" data-id="element-111" data-mp="110lmg17lc07h">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#4ade80]" aria-hidden="true" data-id="element-112" data-mp="w0z7nnc46bwk" />
                  <span className="text-base font-medium text-white" data-id="element-113" data-mp="1lpe2neho8h1s">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-10 text-center font-serif text-2xl font-bold text-wine" data-id="element-114" data-mp="1unyfw04gpyim">
          From disconnected information to organized clinical reasoning.
        </p>

        <SectionCta label="I want to plan with greater clarity" data-id="element-115" data-mp="1zl845cg4844v" />
      </div>
    </section>;
}